import { render, staticRenderFns } from "./ZoneBlock.vue?vue&type=template&id=3db196ba&scoped=true"
import script from "./ZoneBlock.vue?vue&type=script&lang=ts"
export * from "./ZoneBlock.vue?vue&type=script&lang=ts"
import style0 from "./ZoneBlock.vue?vue&type=style&index=0&id=3db196ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db196ba",
  null
  
)

export default component.exports